import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgTools(props) {
    return (
        <Svg width={54} height={52} viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M41.238 5.434v6.328c0 .886-.696 1.582-1.582 1.582a1.567 1.567 0 01-1.582-1.582V5.434c0-.886-.696-1.582-1.582-1.582H17.508c-.886 0-1.582.696-1.582 1.582v6.328c0 .886-.696 1.582-1.582 1.582a1.567 1.567 0 01-1.582-1.582V5.434A4.74 4.74 0 0117.508.687h18.984a4.74 4.74 0 014.746 4.747z"
                fill="#F3F5F9"
            />
            <Path
                d="M41.238 5.434v6.328c0 .886-.696 1.582-1.582 1.582a1.567 1.567 0 01-1.582-1.582V5.434c0-.886-.696-1.582-1.582-1.582H27V.688h9.492a4.74 4.74 0 014.746 4.746z"
                fill="#F3F5F9"
            />
            <Path
                d="M49.254 13.344v34.804l-1.582 3.164H6.328l-1.582-3.164V13.344l1.582-3.164h41.344l1.582 3.164z"
                fill="#F3F5F9"
            />
            <Path d="M49.254 13.344v34.804l-1.582 3.164H27V10.18h20.672l1.582 3.164z" fill="#F3F5F9" />
            <Path
                d="M27 19.672c-6.107 0-11.074 4.968-11.074 11.074 0 6.107 4.967 11.074 11.074 11.074s11.074-4.967 11.074-11.074c0-6.106-4.967-11.074-11.074-11.074z"
                fill={baseColors.green.pastel}
            />
            <Path
                d="M38.074 30.746c0 6.107-4.967 11.074-11.074 11.074V19.672c6.107 0 11.074 4.968 11.074 11.074z"
                fill={baseColors.green.pastel}
            />
            <Path
                d="M49.254 10.18h-1.582v41.133h1.582A4.751 4.751 0 0054 46.566v-31.64a4.751 4.751 0 00-4.746-4.746zM4.746 10.18A4.751 4.751 0 000 14.926v31.64a4.751 4.751 0 004.746 4.746h1.582V10.18H4.746z"
                fill={baseColors.green.dark}
            />
            <Path
                d="M31.746 30.746c0 .886-.696 1.582-1.582 1.582h-1.582v1.582c0 .886-.696 1.582-1.582 1.582a1.567 1.567 0 01-1.582-1.582v-1.582h-1.582a1.567 1.567 0 01-1.582-1.582c0-.886.696-1.582 1.582-1.582h1.582v-1.582c0-.886.696-1.582 1.582-1.582.886 0 1.582.696 1.582 1.582v1.582h1.582c.886 0 1.582.696 1.582 1.582z"
                fill="#F3F5F9"
            />
            <Path
                d="M31.746 30.746c0 .886-.696 1.582-1.582 1.582h-1.582v1.582c0 .886-.696 1.582-1.582 1.582V26c.886 0 1.582.696 1.582 1.582v1.582h1.582c.886 0 1.582.696 1.582 1.582z"
                fill="#F3F5F9"
            />
        </Svg>
    )
}

export default SvgTools
